import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { tryToLoadTokens } from "./user.actions";
import { flushCurrentPage, trackPageChange } from "./tracking";
import Routes from "views/Routes";
import coreReducer from "./core.reducer";
import api from "./api";
import { library as fontawesome } from "@fortawesome/fontawesome-svg-core";
import {
  faTelegram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  faAdjust, faAngleRight, faArrowDown, faArrowLeft, faArrowRight, faArrowUp,
  faBan, faBars, faBell, faBook, faBug,
  faCamera, faCheck, faCheckSquare, faChevronDown, faChevronLeft, faChevronRight, faChevronUp,
  faCircle, faCircleNotch, faClipboard, faCloud, faCloudDownloadAlt, faCloudUploadAlt, faCog, faCommentAlt, faCopy,
  faEdit, faEllipsisH, faEnvelope, faExclamation, faExclamationCircle, faExternalLinkAlt, faEye, faEyeSlash,
  faFileAlt, faFilter, faFlask, faFolder, faFolderOpen,
  faHandPointer, faImage, faInfo, faKey, faLightbulb, faList, faListUl, faLock,
  faLongArrowAltLeft, faLongArrowAltRight,
  faMoon, faPaste, faPlus, faPrint, faQuestion, faRedo, faSave,
  faSearch, faSearchMinus, faSearchPlus, faShareAlt, faSignInAlt, faSignOutAlt, faSpinner, faSyncAlt,
  faTimes, faTrash, faTrashRestore, faUndo, faUniversalAccess, faUniversity, faUser, faUsers, faWifi,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCheckCircle as farCheckCircle,
  faCircle as farCircle,
  faFile as farFile,
  faHourglass as farHourglass,
  faSquare as farSquare,
} from "@fortawesome/free-regular-svg-icons";
import { ToastContainer } from "react-toastify";

export * from "./utils";

fontawesome.add(
  // brands
  faTelegram, faWhatsapp,
  // solid
  faAdjust, faAngleRight, faArrowDown, faArrowLeft, faArrowRight, faArrowUp,
  faBan, faBars, faBell, faBook, faBug,
  faCamera, faCheck, faCheckSquare, faChevronDown, faChevronLeft, faChevronRight, faChevronUp,
  faCircle, faCircleNotch, faClipboard, faCloud, faCloudDownloadAlt, faCloudUploadAlt, faCog, faCommentAlt, faCopy,
  faEdit, faEllipsisH, faEnvelope, faExclamation, faExclamationCircle, faExternalLinkAlt, faEye, faEyeSlash,
  faFileAlt, faFilter, faFlask, faFolder, faFolderOpen,
  faHandPointer, faImage, faInfo, faKey, faLightbulb, faList, faListUl, faLock,
  faLongArrowAltLeft, faLongArrowAltRight,
  faMoon, faPaste, faPlus, faPrint, faQuestion, faRedo, faSave,
  faSearch, faSearchMinus, faSearchPlus, faShareAlt, faSignInAlt, faSignOutAlt, faSpinner, faSyncAlt,
  faTimes, faTrash, faTrashRestore, faUndo, faUniversalAccess, faUniversity, faUser, faUsers, faWifi,
  // regular
  farCheckCircle, farCircle, farFile, farHourglass, farSquare,
);

export { api };

// Criação do `history` para navegação
export const history = createBrowserHistory();

// Configuração do Redux Store
const middlewares = [routerMiddleware(history), thunk];
const compose_with_devtools =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const rootStore = createStore(
  coreReducer(history),
  compose_with_devtools(applyMiddleware(...middlewares))
);

// Dispara ação para carregar tokens no Redux
rootStore.dispatch(tryToLoadTokens());

trackPageChange(history.location);
history.listen((location) => trackPageChange(location));
window.addEventListener("beforeunload", flushCurrentPage);

// 🔥 **Transforme a exportação em um Componente Funcional**
const AppCore = () => (
  <Provider store={rootStore}>
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
    <ToastContainer />
  </Provider>
);

export default AppCore;
